import Api from '@common/services/api';

export const deleteComponent = async (
  organisationId: string,
  formId: string,
  componentId: string
) => {
  await Api.delete(
    `/v1/organisations/${organisationId}/performance/forms/${formId}/components/${componentId}`
  );
};
